var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconamoonClockLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.125C16.7635 20.125 20.625 16.2635 20.625 11.5C20.625 6.73654 16.7635 2.875 12 2.875C7.23654 2.875 3.375 6.73654 3.375 11.5C3.375 16.2635 7.23654 20.125 12 20.125Z",
    stroke: "#A5A5A5",
    strokeWidth: 1.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0417 7.66797V12.4596H15.8334",
    stroke: "#A5A5A5",
    strokeWidth: 1.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconamoonClockLight);
export default __webpack_public_path__ + "static/media/iconamoon_clock-light.5f31cc45512f50a0341a2eb83f049b36.svg";
export { ForwardRef as ReactComponent };